import Button from '@material-ui/core/Button';
import hu from "date-fns/locale/hu";
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { registerLocale } from 'react-datepicker';
import { handleChangeEvent, handlePost } from '../../../../utils/AxiosUtil';
import * as enums from '../../../../utils/EnumMapping';
import { toDateFormat, trimSpaces } from '../../../../utils/Util';
import ErrorAwareAmountField from '../../../common/inputfields/ErrorAwareAmountField';
import ErrorAwareDatePicker from '../../../common/inputfields/ErrorAwareDatePicker';
import ErrorAwareTextField from '../../../common/inputfields/ErrorAwareTextField';
import MyAutocomplete from '../../../common/inputfields/MyAutocomplete';
import NewAgainField from '../../../common/inputfields/NewAgainField';
import PaymentMethodFormControl from '../../../common/inputfields/PaymentMethodFormControl';
import * as util from './OutgoingBillUtil';
import { getFromLocalStorage } from "../../../../utils/Util";

registerLocale("hu", hu)

class NewOutgoingBill extends Component {
    state = {
        newAgain: false,
        customers: [],

        selectedCurrency: enums.currencies[0],
        selectedPaymentMethod: enums.outPaymentMethods[1],
        selectedCustomer: {},
        selectedProject: {},

        billDate: new Date(),
        fulfillmentDate: new Date(),
        paymentDeadline: new Date(),

        vat: null,
        amount: null,

        publicId: '',
        comment: '',

        customerRelatedDropDown: true,
        errors: new Map(),
    }

    resetForm = () => {
        this.setState({
            newAgain: false,
            customers: [],

            selectedCurrency: enums.currencies[0],
            selectedPaymentMethod: enums.outPaymentMethods[1],
            selectedCustomer: {},
            selectedProject: {},

            billDate: null,
            fulfillmentDate: null,
            paymentDeadline: null,

            vat: null,
            amount: null,

            publicId: '',
            comment: '',

            customerRelatedDropDown: true,
            errors: new Map(),
        });
    }

    componentDidMount() {
        this.setBillNumberPrefix();
    };

    setBillNumberPrefix() {
        console.log(this.props);
        const cookies = getFromLocalStorage("Kimenő számlák", 'settings');
        console.log(cookies);
        let value = ''
        if (cookies) {
            cookies.forEach(function (obj) {
                if (obj.name === 'billNumberPrefix') {
                    value = obj.value;
                }
            })
            this.setState({ publicId: value })
        }
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();

        const path = '/api/outgoingbill';
        const requestObject = {
            "currency": this.state.selectedCurrency.value,
            "paymentMethod": this.state.selectedPaymentMethod.value,
            "customerId": this.state.selectedCustomer.value,
            "projectId": this.state.selectedProject.value,

            "billDate": toDateFormat(this.state.billDate),
            "fulfillmentDate": toDateFormat(this.state.fulfillmentDate),
            "paymentDeadline": toDateFormat(this.state.paymentDeadline),

            "vat": trimSpaces(this.state.vat),
            "amount": trimSpaces(this.state.amount),

            "publicId": this.state.publicId,
            "comment": this.state.comment,
        };
        console.log(requestObject)
        handlePost(path, requestObject, this);
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <MyAutocomplete
                            value={this.state.selectedCustomer}
                            getOptions={util.promiseCustomerOptions}
                            onChange={(e, v) => util.handleCustomerSelected(e, v, this)}
                            label={'Megnevezés'}
                            createLabel={'Új vevő'}
                        />
                    </div>
                    <div className='input-group'>
                        <MyAutocomplete
                            value={this.state.selectedProject}
                            getOptions={() => util.promiseProjectOptions(this.state.selectedCustomer)}
                            onChange={(e, v) => util.handleProjectSelected(e, v, this)}
                            disabled={this.state.customerRelatedDropDown}
                            label={'Projekt'}
                            createLabel={'Új projekt'}
                            validate={(p) => util.isValidNewWork(p)}
                            formatHint={"Munkaszám-Helyszín"}
                            customFilter={(options, params) => util.filterForProject(options, params)}
                        />
                    </div>
                    <div className='input-group'>
                        <PaymentMethodFormControl
                            options={enums.outPaymentMethods}
                            value={this.state.selectedPaymentMethod}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            required
                            name="publicId"
                            id="bill-number"
                            label="Számlaszám"
                            errors={this.state.errors}
                            value={this.state.publicId}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            required
                            id="bill-date"
                            name="billDate"
                            label="Számla kelte"
                            errors={this.state.errors}
                            value={this.state.billDate}
                            onChange={(value) => util.handleBillDateChange(value, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            required
                            id="fullfillment-date"
                            name="fullFillmentDate"
                            label="Teljesítés kelte"
                            errors={this.state.errors}
                            value={this.state.fulfillmentDate}
                            onChange={(value) => util.handleFulfillmentDateChange(value, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            required
                            id="payment-deadline-date"
                            name="paymentDeadline"
                            label="Fizetési határidő"
                            errors={this.state.errors}
                            value={this.state.paymentDeadline}
                            onChange={(value) => util.handlePaymentDeadlineChange(value, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareAmountField
                            required
                            id="amount"
                            name="amount"
                            label="Bruttó összeg"
                            value={this.state.amount}
                            errors={this.state.errors}
                            onChange={e => util.handleAmountChange(e, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareAmountField
                            required
                            id="vat"
                            name="vat"
                            label="Áfa összege"
                            value={this.state.vat}
                            errors={this.state.errors}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="comment"
                            label="Megjegyzés"
                            value={this.state.comment}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                    {/*<div className='input-group'>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel id="currency-label">Pénznem</InputLabel>
                                <Select
                                    labelId="currency-label"
                                    id="currency"
                                    value={this.state.selectedCurrency}
                                    onChange={(event) => this.setState({ selectedCurrency: event.target.value })}
                                    label="Pénznem"
                                    disabled={true}>
                                    {enums.currencies.map((value, index) =>
                                        <MenuItem key={index} value={value}>{value.label}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                                    </div>*/}
                </div>
                <div className="form-actions">
                    <NewAgainField
                        checked={this.state.newAgain}
                        onChange={e => this.setState({ newAgain: e.target.checked })} />
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Hozzáadás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(NewOutgoingBill);
